import axios from 'axios'
axios.defaults.withCredentials = true;
const url = 'http://www.api.ucpvirtual.com.br/api/v2/med/'
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
export default {
    
    actions:{

      async  GetDadosMateria (context, value) {
        context.commit('SET_DADOS_MATERIA', value)
        console.log(value)
      
        // context.commit('PRELOADER_MUDAR', true)
        // const AuthStr = 'Bearer ' + localStorage.getItem('access_token')
    
        // await axios.get( url + 'aulas/'+ value,
        //   {
        //     headers: {
        //       'Authorization': AuthStr,
        //       'Content-Type': 'application/json',
        //     },
        //   })
        //   .then(response => {
        //      console.log(response.data)
        //      context.commit('SET_DADOS_MATERIA', response.data)
            
        //   })
        //   .catch((error) => {
        //     console.log(error.response.data.message)
        //   }).finally( () => {
        //         //   context.commit('PRELOADER_MUDAR', false)
        //   })
      },

      async  GetAulas (context, value) {
            console.log(value)
        
            // context.commit('PRELOADER_MUDAR', true)
            const AuthStr = 'Bearer ' + localStorage.getItem('access_token')
        
            await axios.get( url + 'aulas/'+ value.id+'/'+value.parcial,
              {
                headers: {
                  'Authorization': AuthStr,
                  'Content-Type': 'application/json',
                },
              })
              .then(response => {
                 console.log(response.data)
                 context.commit('SET_AULAS', response.data)
               
              })
              .catch((error) => {
                console.log(error.response.data.message)
              }).finally( () => {
                    //   context.commit('PRELOADER_MUDAR', false)
              })
        },

        SetDadosAula(context,value){
          context.commit('SET_DADOS_AULA', value)
        },


    },
    getters:{

    },
    mutations:{
      SET_AULAS (state, value) {
            state.GetAulas =  value
          },
      SET_DADOS_MATERIA (state, value) {
        state.DadosMateria =  value
      },
      SET_DADOS_AULA (state, value) {
        state.DadosAula =  value
      },
        

    },
    state:{
      GetAulas: [],
      DadosMateria:{},
      DadosAula:{},

    },
}